import React from 'react';
import './styles.scss';
interface IVehicleImage {
  url: string;
}
export const VehicleImage: React.FC<IVehicleImage> = ({ url }) => {
  return (
    <div style={{ display: 'flex' }}>
      <div className="vehicle-image-container">
        <img src={url} alt="vehicle" width="350px" />
      </div>
    </div>
  );
};
